/** *******************************************************************************************************************
 * Copyright (c) 2020 - Fundação CERTI
 * All rights reserved.
 ******************************************************************************************************************* */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import DevelopedByCerti from './DevelopedByCerti/DevelopedByCerti';

class Copyright extends Component {
  render() {
    const { showImage } = this.props;

    return (
      <Typography variant="body2" color="textSecondary" align="center">
        {showImage ? <DevelopedByCerti /> : null}
        <br />
        {'Copyright © '}
        <Link color="inherit" href="https://www.certi.org.br/">
          Fundação CERTI
        </Link>
        {` ${new Date().getFullYear()}`}
      </Typography>
    );
  }
}

Copyright.propTypes = {
  showImage: PropTypes.bool,
};

Copyright.defaultProps = {
  showImage: false,
};

export default Copyright;
